import { ActivityInfoIcon } from './ActivityInfoIcon';
import { ActivityInfoText } from './ActivityInfoText';
import { ActivityType } from './ActivityType';
import { SPACING } from '../../config/designSystem/Spacing';
import { View } from 'react-native';



  type ActivityTypeProp = {
    type: ActivityType
  }

export const ActivityInfo  = ({type}: ActivityTypeProp) => {



  return (
    <View style={{flexDirection: 'row', columnGap:SPACING['sp-4'], alignItems:'center'}}>
      <ActivityInfoIcon type={type as ActivityType}/>
      <ActivityInfoText type={type as ActivityType}/>
    </View>
  );
};

export { ActivityType };
